import {
  CreateAffiliationForm,
  Affiliation,
  ValidateAffiliationEmailResponse,
  validateAffiliationEmailDto,
  validateAffiliationPixKeyDto,
  ValidateAffiliationPixKeyResponse,
  AffiliationFilters,
  AffiliatedCommunity,
  UpdateAffiliationSchema,
} from '@interfaces/affiliation';
import { Product } from '@interfaces/product';
import { fetcher } from '@utils/fetcher';
import { mountUrlQueryParams } from '@utils/mountUrlQueryParams';

const getApiUrl = (productId: Product['id']) =>
  `/api/products/${productId}/affiliation`;

export const createAffiliation = async (
  productId: Product['id'],
  dto: CreateAffiliationForm,
): Promise<Affiliation> =>
  fetcher(`${getApiUrl(productId)}`, {
    method: 'POST',
    body: dto,
  });

export const deleteAffiliation = async (
  productId: Product['id'],
  id: Affiliation['id'],
): Promise<void> =>
  fetcher(`${getApiUrl(productId)}/${id}`, {
    method: 'DELETE',
  });

export const updateAffiliation = async (
  productId: Product['id'],
  id: Affiliation['id'],
  dto: UpdateAffiliationSchema,
): Promise<Affiliation> =>
  fetcher(`${getApiUrl(productId)}/${id}`, {
    method: 'PATCH',
    body: dto,
  });

export const findMyAffiliates = async (
  filters: AffiliationFilters,
): Promise<Affiliation[]> => {
  const url = mountUrlQueryParams('/api/affiliation/myAffiliates', filters);
  return fetcher(url);
};

export const findAffiliation = async (
  productId: Product['id'],
  id: Affiliation['id'],
): Promise<Affiliation> => fetcher(`${getApiUrl(productId)}/${id}`);

export const validateAffiliationEmail = async (
  productId: Product['id'],
  dto: validateAffiliationEmailDto,
): Promise<ValidateAffiliationEmailResponse> =>
  fetcher(`${getApiUrl(productId)}/validateEmail`, {
    method: 'POST',
    body: dto,
  });

export const validateAffiliationPixKey = async (
  productId: Product['id'],
  dto: validateAffiliationPixKeyDto,
): Promise<ValidateAffiliationPixKeyResponse> =>
  fetcher(`${getApiUrl(productId)}/validatePixKey`, {
    method: 'POST',
    body: dto,
  });

export const findAffiliatedCommunities = async (): Promise<
  AffiliatedCommunity[]
> => {
  return fetcher('/api/affiliation/affiliatedCommunities');
};

export const deleteCommunityAffiliation = async (
  id: Affiliation['id'],
): Promise<void> =>
  fetcher(`/api/affiliation/affiliatedCommunities/${id}`, {
    method: 'DELETE',
  });
